module.exports = __webpack_public_path__ + "img/card_4.c0de7b8c.jpg";